import { SVGProps } from 'react';

/** Envelope icon used for email extensions (.eml, .msg). */
export const EmailIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 -35.5 169 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M156.5 15L90.8482 64.4637C86.5132 67.7298 80.5255 67.6794 76.246 64.3408L13 15"
        stroke="#8CC5EA"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <rect x="7" y="7" width="155" height="110" rx="20" stroke="#8CC5EA" strokeWidth="14" />
    </svg>
  );
};
